import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClarityModule } from '@clr/angular';

import {
  PlatformBootstrapService,
  PlatformChecks,
} from '../../services/platform-bootstrap.service';
import { SbvpAuthService } from 'src/app/auth/services/sbvp-auth.service';

@Component({
  selector: 'app-platform-degraded-banner',
  imports: [CommonModule, ReactiveFormsModule, ClarityModule],
  templateUrl: './platform-degraded-banner.component.html',
  styleUrls: ['./platform-degraded-banner.component.scss'],
})
export class PlatformDegradedBannerComponent {
  showDetails = false;
  isDismissed = false;
  showRelanceModal = false;
  isLoading = false;
  errorMessage: string | null = null;
  isRepairLoading = false;
  repairError: string | null = null;

  readonly relanceForm: FormGroup;

  constructor(
    public platformService: PlatformBootstrapService,
    public sbvpAuth: SbvpAuthService,
    private fb: FormBuilder,
  ) {
    this.relanceForm = this.fb.group({
      sa_client_id: ['', Validators.required],
      sa_client_secret: ['', Validators.required],
      admin_email: ['', [Validators.required, Validators.email]],
      admin_first_name: ['', Validators.required],
      admin_last_name: ['', Validators.required],
    });
  }

  get isDegraded(): boolean {
    return this.platformService.status === 'degraded';
  }

  get checks(): PlatformChecks | null {
    return this.platformService.checks;
  }

  toggleDetails(): void {
    this.showDetails = !this.showDetails;
  }

  dismiss(): void {
    this.isDismissed = true;
  }

  openRelanceModal(): void {
    this.relanceForm.reset();
    this.errorMessage = null;
    this.showRelanceModal = true;
  }

  repair(): void {
    this.isRepairLoading = true;
    this.repairError = null;
    this.platformService.repair().subscribe({
      next: () => window.location.reload(),
      error: err => {
        this.isRepairLoading = false;
        this.repairError = err?.error?.detail || err?.message || 'Erreur lors de la réparation.';
      },
    });
  }

  submitRelance(): void {
    if (this.relanceForm.invalid) return;
    this.isLoading = true;
    this.errorMessage = null;
    const { sa_client_id, sa_client_secret, admin_email, admin_first_name, admin_last_name } =
      this.relanceForm.value;
    this.platformService
      .bootstrap({ admin_email, admin_first_name, admin_last_name }, sa_client_id, sa_client_secret)
      .subscribe({
        next: () => window.location.reload(),
        error: err => {
          this.isLoading = false;
          this.errorMessage = err?.error?.detail || err?.message || 'Erreur lors du relancement.';
        },
      });
  }
}
